import { rgba } from 'polished';
import { ColorScheme } from 'shared/assets/styles/theme/color-schemes';
import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled, { css } from 'styled-components';

const LinkBase = css`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  min-width: 0;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};

  border-radius: ${({ theme }) => theme.spacing(2)};

  color: ${({ theme }) =>
    rgba(
      theme.palette.text.primary,
      theme.colorScheme === ColorScheme.Dark ? 0.6 : 0.8,
    )};

  &:focus {
    outline: none;
    background: ${({ theme }) => theme.palette.grey[200]};
  }
`;

export const DisabledLink = styled.span`
  ${LinkBase};
`;

export const Link = styled(QueryNavLink)<{ $active: boolean }>`
  ${LinkBase};
  text-decoration: none;

  ${({ $active }) =>
    $active &&
    css`
      ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
      background: ${({ theme }) =>
        theme.palette.primaryExtended.opacityBackgroundBackground};
      color: ${({ theme }) =>
        theme.palette.primaryExtended.opacityBackgroundText};

      &:focus {
        background: ${({ theme }) =>
          theme.palette.primaryExtended.opacityBackgroundBackground};
        color: ${({ theme }) =>
          theme.palette.primaryExtended.opacityBackgroundText};
      }
    `};

  ${({ $active, theme }) =>
    !$active &&
    css`
      &:hover {
        background: ${theme.palette.grey[200]};
      }
    `}
`;

export const SubItemIcon = styled.span<{ $active: boolean }>`
  color: ${({ $active, theme }) =>
    $active
      ? theme.palette.primaryExtended.opacityBackgroundText
      : theme.palette.grey[600]};
  font-size: 1.6rem;
  line-height: 62.5%;
`;

export const LinkTitle = styled.span`
  flex: 1;

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Content = styled.span`
  line-height: 62.5%;
`;
